<template>
  <div style="min-width: 1200px; min-height: 90vh;">
    <q-card style="min-height: 90vh;">
      <q-form ref="form">
        <div class="row q-pa-md">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <h4 class="mt-0 mb-3" style="font-size: 26px; font-weight: 300;">
                Stock Transfer
              </h4>
              <span class="d-block">
                                <q-btn @click="cancelAddOrder" class="q-ml-auto" flat
                                       icon="close" round size="small"></q-btn>
                            </span>
            </div>
          </div>


          <div class=" q-pa-md" style="width: 30%;">
            <div>

              <div class="transferType mb-3">
                <q-radio class="mr-4" color="blue-10" label="Manual" v-model="transferType"
                         val="manual"></q-radio>
                <q-radio color="blue-10" label="Bulk" v-model="transferType" val="bulk"></q-radio>
              </div>
              <div class="my-4">
                <q-select :options="organizationArr"
                          :rules="[val=>val && typeof(val) === 'object' || 'Please select Organization']"
                          @filter="searchOrganization" class="searchBox w-100 p-2 mb-3" clearable
                          label="Select Organizations *" outlined style="width: 41.66%" use-input
                          v-model="selectedOrgObj">
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        No results
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                      <q-item-section>
                        <q-item-label v-html="scope.opt.name"></q-item-label>
                        <q-item-label caption>{{ scope.opt.mobile }}</q-item-label>
                      </q-item-section>
                      <q-item-section>
                        <q-item-label>{{ scope.opt.partnerCode }}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:selected-item="scope">
                    {{ scope.opt.name }}
                  </template>
                </q-select>
              </div>
              <div class="my-4">
                <q-input :rules="[val=>val && val.length>0 || 'Please select order date']"
                         class="searchBox p-2 my-3" filled label="Order Date *"
                         mask="##/##/####"
                         v-model="orderDateComp">
                  <template v-slot:append>
                    <q-icon class="cursor-pointer " name="event">
                      <q-popup-proxy ref="orderDate" transition-hide="scale"
                                     transition-show="scale">
                        <q-date :options="optionsFn"
                                @input="() => $refs.orderDate.hide()" v-model="orderDate"/>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="my-4">
                <q-input :rules="[val=>val && val.length>0 || 'Please enter invoice number']"
                         class="searchBox p-2 my-3" label="Invoice No. *"
                         v-model="invoiceNumber"></q-input>
              </div>
              <div class="my-4">
                <q-input :rules="[val=>val && val.length>0 || 'Please select invoice date']"
                         class="searchBox p-2 my-3" filled label="Invoice Date *"
                         mask="##/##/####"
                         v-model="invoiceDateComp">
                  <template v-slot:append>
                    <q-icon class="cursor-pointer " name="event">
                      <q-popup-proxy ref="invoiceDate" transition-hide="scale"
                                     transition-show="scale">
                        <q-date @input="() => $refs.invoiceDate.hide()"
                                v-model="invoiceDate"/>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="my-4">
                <q-input class="searchBox" label="Note/Remark" style="height: auto;" type="textarea"
                         v-model="invoiceNote"></q-input>
              </div>

            </div>
          </div>


          <template class="my-4 q-pa-md" style="height: 100%;" v-if="transferType==='bulk'">
            <q-input class="searchBox mt-4" label="Batches/ Items"
                     style="width: 70%; text-transform: uppercase; height: 10%;"
                     type="textarea"
                     v-model="transferData"></q-input>
            <div class="q-ml-auto"
                 v-if="groupTwoSelection.length||transferData">
              <q-btn @click="onAddOrder" class="q-ml-auto" color="primary" :loading="checkingBatchLoader"
                     :style="checkingBatchLoader?'font-weight: 300;width:200px':'font-weight: 300'"
                     v-if="groupTwoSelection.length||transferData">
                Transfer
                <template v-slot:loading>
                  <q-spinner class="on-left"/>
                  Checking batches...
                </template>
              </q-btn>
            </div>
          </template>


          <div class="" style="width: 70%;" v-if="transferType==='manual'">
            <div style="width: 100%">
              <div class="d-flex px-3">
                <div class="w-100">
                  <q-input @input="searchBatch" class="mb-3 searchBox p-2 w-100"
                           clearable fill-input outlined use-input debounce="500"
                           label="Search by batch no. to transfer" style="width: 41.66%"
                           v-model="batchObj" :loading="searchBatch_loading">
                  </q-input>
                </div>


              </div>
            </div>

            <div class="d-flex justify-content-between q-pa-md">
              <div style="width: 49%">
                <div class="sectionOne position-relative">
                  <div class="st-header">
                    <div class="d-flex justify-content-between" style="margin-top: 5px;">
                      <q-checkbox label="Select All" v-model="selectAll"></q-checkbox>
                      <div class="mr-2 ">
                        <q-btn @click="addToCart" class="pd-btn"> add</q-btn>
                      </div>
                    </div>
                  </div>

                  <div class="overflow-hidden st-box w-100" style="min-height: 400px !important; margin-top: 45px;">
                    <hr class="mb-3" style="border: 0.5px solid lightgray;">
                    <div class="mt-3 py-3 section-list" v-for="batch in batchArr">
                      <q-checkbox :val="batch" v-model="groupOneSelection">
                        <div>
                          <span style="font-size: 16px; font-weight: 500;">{{ batch.batch }}</span>
                        </div>
                        <div>
                          <span style="font-size: 14px; color: #878787">{{
                              batch.Product
                                  ? batch.Product.name
                                  : '-'
                            }}</span>
                        </div>
                      </q-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 49%;">

                <div class="sectionOne">
                  <div class="st-header">
                    <div class=" d-flex jusutify-content-between"
                         style="align-items: center; margin-top: 5px;">
                      <p style="margin-top: 9px; margin-bottom: 9px; margin-left: 10px;">
                        {{ groupTwoSelection.length }} Selected</p>
                      <div class="q-ml-auto" style="margin-bottom: 3px;"
                           v-if="groupTwoSelection.length||transferData">
                        <q-btn @click="onAddOrder" class="q-ml-auto mr-2" color="primary"
                               style="font-weight: 300"
                               v-if="groupTwoSelection.length||transferData">
                          Transfer
                        </q-btn>
                      </div>
                    </div>
                  </div>

                  <hr class="mb-3 " style="border: 0.5px solid lightgray;  margin-top: 45px;">
                  <div class=" w-100 mt-3 py-3 section-list d-flex justify-content-between"
                       style="cursor: pointer; padding-left: 10px; padding-right: 5px;"
                       v-for="batch in groupTwoSelection">
                    <div>
                      <div class="ml-auto">
                        <span style="font-size: 16px; font-weight: 500;">{{ batch.batch }}</span>
                      </div>
                      <div>
                        <span style="font-size: 14px; color: #878787">{{ batch.Product.name }}</span>
                      </div>
                    </div>
                    <!--                                        <q-checkbox :label="batch.batch" :val="batch"-->
                    <!--                                                    v-model="groupTwoSelection"></q-checkbox>-->
                    <div>
                      <q-btn @click="removeGroupOneSelection(batch)" class="q-ml-auto" flat
                             icon="close" round size="small"></q-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </q-form>
    </q-card>

    <q-dialog position="right" v-model="confirmBatchDialog" persistent>
      <q-card class="q-pa-md">
        <div class="col-12 pl-3">
          <div class="d-flex justify-content-between">
            <h4 class="mt-0 mb-3" style="font-size: 26px; font-weight: 300;">
              Confirm Order
            </h4>
            <div class="d-block">
              <q-btn dense flat icon="close" v-close-popup>
                <q-tooltip>Close</q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>
        <q-card-section style="width:500px; min-height: 600px" class="bg-white text-black">
          <p class="text-grey">Following is the verification list of total
            {{ bulkObj.validBatches.length + bulkObj.invalidBatches.length + bulkObj.duplicateBatches.length }}
            entered batches</p>
          <q-list bordered>
            <template v-for="(value , key) in bulkObj">
              <q-expansion-item>
                <template slot="header">
                  <q-item-section>
                    <div class="d-flex" style="align-items: center">
                      <div class="od-count px-2" :class="getColor(key)" style="box-shadow: none !important;">
                        {{ value.length }}
                      </div>
                      <p class="mb-0 ml-3 text-capitalize">{{ key.replace(/([a-z])([A-Z])/g, '$1 $2') }}</p>
                    </div>

                  </q-item-section>
                </template>
                <q-card class="co-accordion px-3">
                  <q-card-section>
                    <ul style="list-style: none">
                      <li :key="i" class="col-3" tag="label"
                          v-for="(batch, i) in value" v-ripple>
                        <p class="my-2">{{ batch }}</p>
                        <q-separator/>
                      </li>
                    </ul>
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-separator/>
            </template>
          </q-list>
        </q-card-section>

        <!--                <q-card-section style="width:400px" class="bg-white text-black">-->
        <!--                    Following is the verification list of total-->
        <!--                    {{bulkObj.validBatches.length+bulkObj.invalidBatches.length+-->
        <!--                      bulkObj.duplicateBatches.length+bulkObj.alreadyExistBatches.length}} entered batches-->
        <!--                    <p v-if="!bulkObj.validBatches.length" style="color: red;font-weight: bolder; font-size: 16px;margin:6px 0px -14px 0px;"><q-icon><i class="fas fa-exclamation-triangle" style="color: red;margin-right: 4px"></i></q-icon> No Valid Batch Found !</p>-->
        <!--                    <p class="mt-4">Valid Batches ({{bulkObj.validBatches.length}}) :  <span v-for="(batch, index) in bulkObj.validBatches">{{batch}}-->
        <!--                        <template v-if="index+1<bulkObj.validBatches.length">, </template></span></p>-->
        <!--                    <p>Invalid Batches ({{bulkObj.invalidBatches.length}}) : <span v-for="(batch, index) in bulkObj.invalidBatches">{{batch}}-->
        <!--                        <template v-if="index+1<bulkObj.invalidBatches.length">, </template></span></p>-->
        <!--                    <p>Duplicate Batches ({{bulkObj.duplicateBatches.length}}) : <span v-for="(batch, index) in bulkObj.duplicateBatches">{{batch}}-->
        <!--                        <template v-if="index+1<bulkObj.duplicateBatches.length">, </template></span></p>-->
        <!--                    <p>Existing Batches ({{bulkObj.alreadyExistBatches.length}}) : <span v-for="(batch, index) in bulkObj.alreadyExistBatches">{{batch}}-->
        <!--                        <template v-if="index+1<bulkObj.alreadyExistBatches.length">, </template></span></p>-->
        <!--                </q-card-section>-->
        <div>
          <p class="pl-3 mb-0">Only {{ bulkObj.validBatches.length }} valid batches will be transferred</p>
        </div>
        <q-card-actions align="right">
          <div>
            <q-btn flat label="Cancel" v-close-popup/>
            <q-btn flat :label="'Transfer ('+bulkObj.validBatches.length+')'" class="pd-btn ml-3"
                   :disabled="!bulkObj.validBatches.length" @click="insertOrder(bulkObj.validBatches.length)"/>
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!--        <q-dialog v-model="confirmBatchDialog" persistent>-->
    <!--            <q-card class="bg-primary text-white">-->
    <!--                <q-bar>-->
    <!--                    <div>CONFIRM ORDER</div>-->
    <!--                    <q-space />-->
    <!--                    <q-btn dense flat icon="close" v-close-popup>-->
    <!--                        <q-tooltip>Close</q-tooltip>-->
    <!--                    </q-btn>-->
    <!--                </q-bar>-->

    <!--                <q-card-section style="width:400px" class="bg-white text-black">-->
    <!--                    Following is the verification list of total-->
    <!--                    {{bulkObj.validBatches.length+bulkObj.invalidBatches.length+bulkObj.duplicateBatches.length}} entered batches:-->
    <!--                    <p v-if="!bulkObj.validBatches.length" style="color: red;font-weight: bolder; font-size: 16px;margin:6px 0px -14px 0px;"><q-icon><i class="fas fa-exclamation-triangle" style="color: red;margin-right: 4px"></i></q-icon> No Valid Batch Found !</p>-->
    <!--                    <p class="mt-4">Valid Batches ({{bulkObj.validBatches.length}}) :  <span v-for="(batch, index) in bulkObj.validBatches">{{batch}}-->
    <!--                        <template v-if="index+1<bulkObj.validBatches.length">, </template></span></p>-->
    <!--                    <p>Invalid Batches ({{bulkObj.invalidBatches.length}}) : <span v-for="(batch, index) in bulkObj.invalidBatches">{{batch}}-->
    <!--                        <template v-if="index+1<bulkObj.invalidBatches.length">, </template></span></p>-->
    <!--                    <p>Duplicate Batches ({{bulkObj.duplicateBatches.length}}) : <span v-for="(batch, index) in bulkObj.duplicateBatches">{{batch}}-->
    <!--                        <template v-if="index+1<bulkObj.duplicateBatches.length">, </template></span></p>-->
    <!--                </q-card-section>-->
    <!--                <q-card-actions align="right" class="bg-white text-teal">-->
    <!--                    <q-btn flat label="Transfer" :disabled="!bulkObj.validBatches.length" @click="insertOrder(bulkObj.validBatches.length)"/>-->
    <!--                    <q-btn flat label="Cancel" v-close-popup />-->
    <!--                </q-card-actions>-->
    <!--            </q-card>-->
    <!--        </q-dialog>-->

  </div>
</template>

<script>
const findDuplicates = (arr) => {
  let sorted_arr = arr.slice().sort()
  let results = []
  for (let i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1] == sorted_arr[i]) {
      results.push(sorted_arr[i])
    }
  }
  return results
}
import { GET_INVENTORY_BY_BATCH, CHECK_ENTERED_BATCHES } from '../graphql/queries/products'
import { INSERT_ORDER_ITEMS, INSERT_ORDERS } from '../graphql/mutations/products'
import { SEARCH_ORGANIZATION_IN_STOCK_TRANSFER } from '../graphql/queries/organization'
import moment from 'moment'

export default {
  name: 'StockTransfer',
  props: ['to_orgId', 'to_orgName', 'to_orgObj'],
  apollo: {
    Organizations: {
      query: SEARCH_ORGANIZATION_IN_STOCK_TRANSFER,
      fetchPolicy: 'network-only',
      variables () {
        return {
          orgFilter: this.orgFilter,
          // partnerType: not in VAD, RD and NP(for VAD loggedIn) & not in RD and NP(for RD loggedIn)
          prefferedVP: JSON.parse(localStorage.getItem('user')).orgId,
          partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType ===
          '3260ebcf-8944-4dc1-a003-9997b0e07811' ?
              [
                '3260ebcf-8944-4dc1-a003-9997b0e07811',
                '917370fd-9532-4f84-bd30-9b6f0777e206',
                '9260ebcf-8944-4dc1-a003-9997b0e07811'] :
              ['917370fd-9532-4f84-bd30-9b6f0777e206', '9260ebcf-8944-4dc1-a003-9997b0e07811'],
        }
      },
      // debounce: 500,
      // skip: true,
      result ({ data, loading }) {
        if (!loading) {
          this.organizationArr = data.Organizations
        }
      },
    },
  },
  data: function () {
    return {
      moment: moment,
      user: JSON.parse(localStorage.getItem('user')),
      batchArr: [],
      groupOneSelection: [],
      groupTwoSelection: [],
      batchObj: '',
      searchBatch_loading: false,
      batchFilter: '%%',
      transferType: 'manual',
      transferData: '',
      selectAll: false,
      organizationArr: [],
      orgFilter: '%%',
      selectedOrgObj: '',
      invoiceNumber: '',
      invoiceNote: '',
      invoiceDate: moment(),
      invoiceDateComp: moment().format('DD/MM/YYYY'),
      orderDate: moment(),
      orderDateComp: moment().format('DD/MM/YYYY'),
      checkingBatchLoader: false,
      bulkObj: { validBatches: [], invalidBatches: [], duplicateBatches: [] },
      confirmBatchDialog: false,
    }
  },
  watch: {
    selectAll () {
      if (this.selectAll) {
        this.groupOneSelection = []
        this.batchArr.forEach(batch => {
          this.groupOneSelection.push(batch)
        })
      } else {
        this.groupOneSelection = []
      }
    },
    invoiceDate (val) {
      this.invoiceDateComp = moment(val).format('DD/MM/YYYY')
    },
    orderDate (val) {
      this.orderDateComp = moment(val).format('DD/MM/YYYY')
    },
  },
  methods: {
    getColor (val) {
      if (val === 'validBatches')
        return 'success'
      else if (val === 'invalidBatches')
        return 'error'
      else if (val === 'duplicateBatches')
        return 'warning'
      else
        return 'info'

    },
    optionsFn (date) {
      return date >= moment().subtract(7, 'days').format('YYYY/MM/DD') && date <= moment().format('YYYY/MM/DD')
    },
    async searchBatch (val) {
      let splitted = val.split(' ')
      if (splitted.length <= 1) {
        if (val.length < 1) {
          return
        }
        this.searchBatch_loading = true
        let response = await this.$apollo.query({
          query: GET_INVENTORY_BY_BATCH,
          fetchPolicy: 'network-only',
          variables: {
            ownedBy: this.user.orgId,
            batchFilter: '%' + val + '%',
            status: 'InStock',
          },
        })
        if (response.data) {
          this.batchArr = response.data.BatchTable
          this.searchBatch_loading = false
        }
      }
    },
    searchOrganization (val, update, abort) {
      if (val.length < 1) {
        abort()
        return
      }
      update(() => {
        this.orgFilter = '%' + val + '%'
      })
    },
    removeGroupOneSelection (batch) {
      var index = this.groupOneSelection.findIndex(function (item) {
        return item.id === batch.id
      })
      if (index > -1)
        this.groupOneSelection.splice(index, 1)
    },
    cancelAddOrder () {
      this.groupOneSelection = []
      this.groupTwoSelection = []
      this.$emit('closeStockTransferDialog', false)
    },
    addToCart () {
      this.groupTwoSelection = this.groupOneSelection
    },
    onAddOrder () {
      let self = this
      this.$refs['form'].validate().then(success => {
        if (success) {self.addOrder()}
      })
    },
    async addOrder () {
      // add order
      let self = this
      let batches
      //manual transfer
      if (this.transferType === 'manual') {
        batches = this.groupTwoSelection ? this.groupTwoSelection.length : 0
        //check empty
        if (batches == 0) {
          this.$q.notify('Please Enter/Select atleast one batch item.')
        } else {
          self.confirmInsertOrder(batches)
        }
      } else if (this.transferType === 'bulk') {
        //get data from bulk entries
        this.checkingBatchLoader = true
        let enteredBatches = this.transferData.split('\n').
            filter((str) => /\S/.test(str)).
            map((batch) => batch.trim().toUpperCase())
        this.groupOneSelection = this.transferData.split('\n').
            filter((str) => /\S/.test(str)).
            map((batch) => batch.trim().toUpperCase())
        let response = await this.$apollo.query({
          query: CHECK_ENTERED_BATCHES,
          fetchPolicy: 'network-only',
          variables: { batches: this.groupOneSelection, ownedBy: this.user.orgId },
        })
        if (response.data) {this.checkingBatchLoader = false}
        this.groupOneSelection = response.data.BatchTable

        this.bulkObj = { validBatches: [], invalidBatches: [], duplicateBatches: [] }
        this.bulkObj.invalidBatches = enteredBatches.filter(
            (batch) => !self.groupOneSelection.find((obj) => obj.batch == batch))
        this.bulkObj.validBatches = self.groupOneSelection.map((obj) => obj.batch)
        this.bulkObj.duplicateBatches = findDuplicates(enteredBatches)
        this.confirmBatchDialog = true
      }
    },
    confirmInsertOrder (batches) {
      let self = this
      this.$q.dialog({
        title: 'Confirm',
        message: 'Are you sure? ',
        cancel: true,
        persistent: false,
      }).onOk(() => {
        self.insertOrder(batches)
      }).onCancel(() => {
        // console.log('>>>> Cancel')
      })
    },
    async insertOrder (batches) {
      let self = this
      let toOrgId = this.selectedOrgObj.id       //as per props passed
      let orderRequest = {
        id: this.generateUUID(),
        date: self.orderDate,
        from: self.user.orgId,
        to: toOrgId,
        lineItemCounts: batches,
        status: 'InTransit',
        placedBy: self.user.id,
        notes: '',
        invoiceNumber: self.invoiceNumber,
        invoiceNote: self.invoiceNote,
        invoiceDate: self.invoiceDate,
        orderType: 1,
      }
      let response = await this.$apollo.mutate({
        mutation: INSERT_ORDERS,
        variables: orderRequest,
      })
      if (response.data) {
        self.addOrderItems(orderRequest)
      }
    },
    addOrderItems (orderRequest) {
      // add order items
      let self = this
      let toOrgId = this.selectedOrgObj.id            //as per props passed
      let orderItemRequest
      self.groupOneSelection.forEach(inv => {
        orderItemRequest = {
          id: self.generateUUID(),
          orderId: orderRequest.id,
          qty: orderRequest.lineItemCounts,
          from: self.user.orgId,
          to: toOrgId,
          notes: '',
          sellType: '1',
          batchId: inv.id,
          productInventoryId: toOrgId,
          productId: inv.productId,
          status: 'InTransit',
          meta: null,
        }
        let response = this.$apollo.mutate({
          mutation: INSERT_ORDER_ITEMS,
          variables: orderItemRequest,
        }).then(res => {
          console.log(res)
          // self.updateProductInventory(sameSerials)
        }).catch(err => {
          console.log(err)
        })
      })
      this.groupOneSelection = []
      this.groupTwoSelection = []
      this.confirmBatchDialog = false
      this.$q.notify('Batch Transfer Successfully')
      this.$emit('closeStockTransferDialog', false)
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
  },
  mounted () {
    if (this.to_orgObj) {
      this.selectedOrgObj = {
        name: this.to_orgObj.name, mobile: this.to_orgObj.mobile,
        id: this.to_orgObj.id, referralCode: this.to_orgObj.referralCode, partnerCode: this.to_orgObj.partnerCode,
      }
    }
  },
}
</script>

<style scoped>


</style>
